const isInViewport = function (elem) {
  const bounding = elem.getBoundingClientRect();
  return (
    bounding.top >= 0 &&
    bounding.left >= 0 &&
    bounding.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    bounding.right <=
      (window.innerWidth || document.documentElement.clientWidth)
  );
};

const videoEmbed = document.getElementsByClassName('wistia_embed');

Array.prototype.forEach.call(videoEmbed, (videoLoad) => {
  // const videoId = videoLoad.getAttribute('data-video-id');
  // const videoHandle = videoLoad.getAttribute('data-video-handle');
  // console.log(videoId);

  window._wq = window._wq || [];
  _wq.push({
    // id: videoId,
    id: '_all',
    onReady(video) {
      // console.log(`Video: ${videoHandle}`);
      window.addEventListener(
        'scroll',
        (event) => {
          if (isInViewport(videoLoad)) {
            // console.log(`${videoId} - visible`);
            video.unmute();
          } else {
            // console.log(`${videoId} - hidden`);
            // console.log(video);
            video.pause();
          }
        },
        false,
      );
    },
  });
});

// const videoContainer = document.getElementById(
//   'wistia--{{videoblockUrlReady}}'
// );

// window._wq = window._wq || [];
// _wq.push({
//   id: '{{videoblockUrlReady}}',
//   onReady(video) {
//     console.log('I got a handle to the video!', video);
// window.addEventListener(
//   'scroll',
//   function (event) {
//     if (isInViewport(videoContainer)) {
//       // console.log('Video Visible');
//     } else {
//       video.pause();
//     }
//   },
//   false
// );
//   },
// });

// const video = document.getElementsByClassName('rte__video-wrapper');

// Array.prototype.forEach.call(video, function (vid) {
//   const vidId = vid.getAttribute('data-video-id');
//   const videoPlayer = Wistia.api(vidId);

//   console.log(videoPlayer);

//   window.addEventListener(
//     'scroll',
//     function (event) {
//       if (isInViewport(vid)) {
//         // console.log('Video Visible');
//       } else {
//         videoPlayer.pause(vidId);
//       }
//     },
//     false
//   );
// });

// const isInViewport = function (elem) {
//   const bounding = elem.getBoundingClientRect();
//   return (
//     bounding.top >= 0 &&
//     bounding.left >= 0 &&
//     bounding.bottom <=
//       (window.innerHeight || document.documentElement.clientHeight) &&
//     bounding.right <=
//       (window.innerWidth || document.documentElement.clientWidth)
//   );
// };

// V2
// const isInViewport = function (elem) {
//   const bounding = elem.getBoundingClientRect();
//   return (
//     bounding.top >= 0 &&
//     bounding.left >= 0 &&
//     bounding.bottom <=
//       (window.innerHeight || document.documentElement.clientHeight) &&
//     bounding.right <=
//       (window.innerWidth || document.documentElement.clientWidth)
//   );
// };
// window._wq = window._wq || [];
// _wq.push({
//   id: '{{videoblockUrlReady}}',
//   onReady(video) {
//     console.log('I got a handle to the video!', video);
//     window.addEventListener(
//       'scroll',
//       function (event) {
//         if (isInViewport(vid)) {
//           // console.log('Video Visible');
//         } else {
//           video.pause();
//         }
//       },
//       false
//     );
//   },
// });
